// 导航条顶边自动滑到可视区函数
// @ element 元素
// @ scrollDomClass 滑动盒子元素
// @ ScreenDistance 元素滑动之后离屏幕边距
function autoNavBar (element,scrollDomClass,ScreenDistance){
        const  left = element.getBoundingClientRect().left
        const  right = element.getBoundingClientRect().right
        const clientWidth = window.innerWidth || document.documentElement.clientWidth
        const clientRight = clientWidth-right
        if(clientRight < ScreenDistance){
          let distance 
          if(clientRight<0){
               distance = Math.abs(clientRight)+ScreenDistance
           }else{
               distance = ScreenDistance - clientRight
           }
           document.getElementsByClassName(scrollDomClass)[0].scrollLeft += distance
        }
        if(left<ScreenDistance){
          let distance
          if(left<0){
            distance = Math.abs(left)+ScreenDistance
          }else{
            distance = ScreenDistance - left
          }
          document.getElementsByClassName(scrollDomClass)[0].scrollLeft -= distance
        }
  }